import React from "react";
import OrdersInfoAddressList from "../../../order-info/components/OrdersInfoAddressList";
import OrdersInfoDirections from "../../../order-info/components/OrdersInfoDirections";
import OrdersInfoCargo from "../../../order-info/components/OrdersInfoCargo";
import YandexMap from "../../../order-info/components/YandexMap";
import CargoComment from "../CargoComment/CargoComment";

const RouteTab = ({
  order,
  cargoDetails,
  companyName,
  recipient,
  cityFrom,
  cityTo,
  routeData,
  isLoadingMap,
  coordinateTruck = [],
}) => {
  if (!order) return null;

  return (
    <>
      <div style={{ width: "100%", height: "230px" }}>
        <YandexMap
          item={order}
          addressList={order.addressList}
          cityFrom={cityFrom}
          cityTo={cityTo}
          routeData={routeData}
          isLoadingMap={isLoadingMap}
          coordinateTruck={coordinateTruck}
          allowExpand
        />
      </div>
      {order && order.addressList && (
        <OrdersInfoAddressList order={order} addressList={order.addressList} />
      )}
      <OrdersInfoCargo item={cargoDetails} order={order} isDetails={false} tnvedCode={order?.tnvedCode} />
      <CargoComment comment={cargoDetails?.details} />
    </>
  );
};

export default RouteTab;
